export default function useHandleKey() {
  const handleKeyDown = (event: KeyboardEvent, callback: Function) => {
    if (event.key === 'Enter') callback();
  };

  return { handleKeyDown };
}